import InformationCircleIcon from '@ingka/ssr-icon/paths/information-circle';
import { ComponentIds, Entity, ProductComponent } from '@inter-ikea-core/core';
import { useAppDispatch } from 'ducks/hooks';
import { showProductDetails } from 'ducks/layout';
import { getMarketProducts } from 'ducks/products';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ContextButton from '../ContextButton';
import { InfoActionTargetComponent } from '@inter-ikea-storageone/range';

const DisabledText = styled.div`
  display: none;
  :not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

type Props = {
  selectedEntity: Entity;
  size?: 'xsmall' | 'small' | 'medium';
};

const Wrapper = styled.div``;

const Info = ({ selectedEntity, size }: Props) => {
  const { formatMessage } = useIntl();
  const products = useSelector(getMarketProducts);
  const dispatch = useAppDispatch();

  const onInfoClicked = () => {
    const product = products.find(p => {
      if (selectedEntity.hasComponent(InfoActionTargetComponent.id))
        return (
          p.coreProductId ===
          selectedEntity.getComponent<InfoActionTargetComponent>(InfoActionTargetComponent.id)
            ?.targetProductId
        );
      else
        return (
          p.coreProductId ===
          selectedEntity.getComponent<ProductComponent>(ComponentIds.PRODUCT_COMPONENT_ID)
            ?.productRef
        );
    });

    if (product) {
      dispatch(
        showProductDetails({
          productId: product.coreProductId,
          cluster: [product]
        })
      );
    }
  };

  return (
    <Wrapper>
      <ContextButton
        label={formatMessage({ id: 'storageone.contextMenuInfo' })}
        dataTestId="info"
        onClick={onInfoClicked}
        ssrIcon={InformationCircleIcon}
        size={size}
      >
        <DisabledText>{formatMessage({ id: 'storageone.contextMenuInfo' })}</DisabledText>
      </ContextButton>
    </Wrapper>
  );
};

export default Info;
